import {
  CULTURALPRETEMPOSTSUCCESS,
  CULTURALPRETEMPOSTFAIL,
} from "../actionTypes";
const initialState = {
  postTemp: [],
};
const cultrurePreBuiltTemplatePostReducer = (state = initialState, action) => {
  switch (action.type) {
    case CULTURALPRETEMPOSTSUCCESS:
      return {
        ...state,
        postTemp: action.payload,
      };
    case CULTURALPRETEMPOSTFAIL:
      return {
        ...state,
        postTemp: null,
      };
    default:
      break;
  }
  return state;
};
export default cultrurePreBuiltTemplatePostReducer;
